/* eslint-disable jsx-a11y/anchor-is-valid */
import "moment/locale/pt-br";
import { formatMoney } from "../../../infra/helpers";
import type { ColumnsType } from "antd/es/table";
import { formatNumber } from "../../../infra/helpers/number";

export const columns: ColumnsType = [
  {
    title: "Caneca",
    dataIndex: "Caneca",
    key: "Caneca",
    width: 100,
  },
  {
    title: "Botijão",
    dataIndex: "Botijao",
    key: "Botijao",
    width: 150,
  },
  {
    title: "Produto",
    dataIndex: "ProdutoNome",
    key: "ProdutoNome",
    width: 250,
  },
  {
    title: "Tipo",
    dataIndex: "Tipo",
    key: "Tipo",
    width: 100,
  },
  {
    title: "Valor unitário",
    dataIndex: "ValorUnitarioReais",
    key: "ValorUnitarioReais",
    render(valor: number) {
      return formatMoney(valor);
    },
    align: "right",
    width: 150,
  },
  {
    title: "Desconto",
    dataIndex: "DescontoPorcentagem",
    key: "DescontoPorcentagem",
    render(valor: number) {
      return `${formatNumber(valor)}%`;
    },
    align: "right",
    width: 100,
  },
  {
    title: "Qtde",
    dataIndex: "Quantidade",
    key: "Quantidade",
    align: "right",
    width: 100,
  },
  {
    title: "Retirante",
    dataIndex: "RetiranteContato",
    key: "RetiranteContato",
    width: 250,
  },
];
